import { Status } from '../status';


export class StatusSerializer {
    fromJson(json: any): Status {
        const data = new Status();
        data.value = json.id;
        data.label = json.name;
        return data;
    }

    toJson(data: Status): any {
        return {
            id: data.id,
            name: data.name
        };
    }
}